import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";

// components
import {getStateByPath} from "../../../../redux/selectors";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {GenericButton} from "../../../../components/buttons/customButtons";

// labels
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";

// actions
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

//services
import {pageSectionService} from "../../../../jwt/_services/landings/pageSectionService";

const SectionsList = (props) => {

    const path = `${props.path}/sections`;

    const pageState = useSelector(state => getStateByPath(state, props.path));
    const {app, domainObject: page} = pageState?.data || {};

    const componentState = useSelector(state => getStateByPath(state, path));
    const {listDomainObjects} = componentState?.data || {};

    const {fbDataBase} = app

    const [loading, setLoading] = useState(true)


    useEffect(() => {
        const dataRequest = {
            fbDataBase,
            item: {
                page: { id: page?.id }
            }
        }

        genericIndexedActions.search(path, pageSectionService, 0, 1000, dataRequest, handleLoadingChange)
    }, []);


    const handleLoadingChange = () => setLoading(!loading)


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        closeOnEscape: false,
        closeOnClickOutside: false,
        fbDataBaseId: fbDataBase?.id,
        service: pageSectionService,
        remove : genericIndexedActions.delete,
    } );


    const renderContent = (item, index) => <div key={index} className={'dnd-item'}>
        <Row>
            <Col className={'dnd-title'}>
                {item?.section?.description}
            </Col>
            <Col>
                <div className={'actions'}>
                    <GenericTableButton
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={()=>props.onEdit(item?.section)}
                    />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => confirmDelete(item)}
                    />
                </div>
            </Col>
        </Row>
    </div>




    if (loading)
        return <center>
            <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
            <br/><br/>
            Cargando...
        </center>

    if (listDomainObjects.length === 0)
        return <center>
            <i className="fa fa-ban fa-fw fa-3x fa-fw"/>
            <br/><br/>
            No hay elementos para mostrar
        </center>

    return <>
        {
            listDomainObjects.map((item, index)=> renderContent(item, index))
        }
    </>
}

export default SectionsList;